var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlcoholimetroNoSuperado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241.52 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#630021;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alcoholimetro-no-superado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_8",
    "data-name": 8
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.42,254.74H30.8A23.63,23.63,0,0,1,10.34,219.3L63.65,127h0a23.63,23.63,0,0,1,40.92,0l53.31,92.34a23.63,23.63,0,0,1-20.46,35.44ZM84.11,133.19A5.48,5.48,0,0,0,79.27,136h0L26,228.32a5.59,5.59,0,0,0,4.84,8.38H137.42a5.59,5.59,0,0,0,4.83-8.38L88.94,136A5.47,5.47,0,0,0,84.11,133.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.47,211.58a7.94,7.94,0,0,1,0,10.78,8,8,0,0,1-10.73,0,7.61,7.61,0,0,1,10.73-10.78ZM91,161.41a1,1,0,0,1,.3.73v42.35a1,1,0,0,1-1,1H78.09a1,1,0,0,1-.73-.3,1,1,0,0,1-.3-.73V162.14a1,1,0,0,1,.3-.73,1,1,0,0,1,.73-.3h12.2A1,1,0,0,1,91,161.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,0V14H54.79V26.56H27.34a27.34,27.34,0,1,0,0,54.67H54.79V93.75l40.48-.12V14.27h132V240.85H185.47v14.27h56.05V0ZM27.34,67a13.07,13.07,0,0,1,0-26.14H54.79V67ZM69.06,28.31H81V79.48h-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.29,33.54H113.08v80.81h94.21ZM193,100.09H127.34V47.81H193Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,210a7.13,7.13,0,0,1-2.78-13.7A24,24,0,1,0,147,154.11a7.13,7.13,0,0,1-7.86-11.9,38.3,38.3,0,1,1,36,67.26A7.14,7.14,0,0,1,172.32,210Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlcoholimetroNoSuperado);
export default __webpack_public_path__ + "static/media/ic-alcoholimetro-no-superado.532738f9f755a27eed6a75852e269cdd.svg";
export { ForwardRef as ReactComponent };